import OakLogo from "@/components/OakLogo";

export default function LoadingScreen({ label = "Loading OAK…" }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-5" data-testid="loading-screen">
      <div className="animate-float">
        <OakLogo size={64} glow />
      </div>
      <div className="label-eyebrow" data-testid="loading-label">{label}</div>
      <div className="w-40 h-[2px] bg-white/5 overflow-hidden rounded-full">
        <div className="sheen h-full w-full" />
      </div>
    </div>
  );
}
